import { apiFactory } from "generated";
import AxiosInstance from "./axiosInstance";

export const gatewayClient = apiFactory.getGatewaysInstance(AxiosInstance);

export const gatewayGroupClient =
    apiFactory.getGatewaygroupsInstance(AxiosInstance);

export const firmwareClient = apiFactory.getFirmwareInstance(AxiosInstance);
